<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-green">
        <div class="container-fluid">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03"
                aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation" v-if="flag!=0">
                <span class="navbar-toggler-icon"></span>
            </button>
            <a class="navbar-brand" href="#">
                <img src="../../assets/nwmissouri-logo-online.webp" alt="ltc-logo" height="55" width="200"
                    class="d-inline-block align-text-top" /></a>
            <div class="collapse navbar-collapse" id="navbarTogglerDemo03" v-if="flag!=0">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li class="nav-item text-white fw-bold item-nav">
                        <span class="material-icons-outlined icon-menu">
                            account_circle
                        </span>{{ $store.state.username }}
                    </li>
                    <li class="nav-item text-white fw-bold item-nav">
                        <a @click="logout" class="text-white cursor-pointer text-decoration-none"> <span class="material-icons-outlined icon-menu">
                                logout
                            </span>Signout</a>
                    </li>
                </ul>

            </div>

            <!-- <div 
        class="collapse navbar-collapse"
        id="navbarTogglerDemo03"
        v-if="details != null"
      >
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item" v-for="menu in details.MenuItems" :key="menu.id">
            <a class="nav-link text-white fw-bold" aria-current="page" :href='menu.Routerlink'
              ><span class="material-icons-outlined icon-menu">
                {{ menu.Icon }}
              </span>
              {{ menu.Name }}</a
            >
          </li>
          <li class="nav-item dropdown ml-auto">
            <div class="btn-group">

              <a
                class="nav-link dropdown text-white"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded="false"
              >
                <span class="material-icons-outlined icon-user">
                  {{ details.Profile[0].Icon }}
                </span>
              </a>
              <ul class="dropdown-menu dropdown-menu-lg-end">
                <li><a class="dropdown-item fw-bold" href="#">{{details.Profile[0].Username}}</a></li>
                <li><hr class="dropdown-divider"></li>
                <li><a class="dropdown-item fw-bold" href="#"><span class="material-icons-outlined icon-menu">
                  logout
                </span>{{details.Profile[0].Status}}</a></li>
              </ul>
            </div>
          </li>
        </ul>
      </div>-->
        </div>
    </nav>




</template>
<script>
export default {
    methods: {
        logout() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/faculty-login")
            })
        }
    },
    props:{
      flag:Number,
    }
}
</script>

<style scoped>
.j-c-n {
    justify-content: normal !important;
}

.item-nav {
    padding: 6px;
}

.icon-menu {
    vertical-align: top;
}

.bg-green {
    background-color: #006747;
}

.navbar-brand {
    padding-left: 30px;
}

.title-logo {
    float: left;
    align-items: center;
    text-transform: uppercase;
    font-size: 23px;
    font-weight: 500;
    line-height: 1em;
    color: #fff;
    text-decoration: none;
    position: relative;
}
</style>